import { createContext } from 'react';

export type CubohDateRange = { start: string; end: string };

// Only the fields Location Home owns are typed; the rest of the provider's value stays loose
export type CubohActionBarValue = {
  selectedDateRange: CubohDateRange;
  selectedTimezone: string;
  setSelectedDateRange: (range: CubohDateRange) => void;
  setSelectedTimezone: (timezone: string) => void;
  showTimezoneSelect: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const CubohActionBarContext = createContext<CubohActionBarValue>(
  undefined as unknown as CubohActionBarValue,
);

export default CubohActionBarContext;
